import maskConfig from './stream-mask.config.json';

const pct = (v) => (String(v).includes('%') ? v : `${Number(v) * 100}%`);

/** Maska prywatności rysowana w przeglądarce (rozmycie strefy kadru). */
export const STREAM_PRIVACY_MASK = {
    enabled: true,
    blur: {
        left: pct(maskConfig.blur.left),
        top: pct(maskConfig.blur.top),
        width: pct(maskConfig.blur.width),
        height: pct(maskConfig.blur.height),
    },
};

/** Zrzut ekranu — ta sama maska, opcjonalnie wydłużona w dół. */
export const STREAM_PRIVACY_MASK_SCREENSHOT = {
    ...STREAM_PRIVACY_MASK,
    extendBottom: '50%',
};
